module.exports = __webpack_public_path__ + "static/media/UP_wyl.9dc7ddae.svg";